import { apiClient } from "./api";

export interface CreatePaymentIntentParams {
  amount: number;
  persona_id: string;
}

export const createPaymentIntent = async (
  params: CreatePaymentIntentParams,
) => {
  try {
    const response = await apiClient.post(
      "/api/stripe/create-payment-intent",
      params,
    );
    return response.data;
  } catch (error) {
    console.error("Error creating payment intent:", error);
    throw error;
  }
};
